/* =========================================================================
   WWC CRO-concept - levertijdmodule
   Instellingen: snippets/wwc-cro-delivery.liquid

   WAT DE TEST AAN HET LICHT BRACHT
   De belofte "binnen 3 werkdagen" staat TWAALF keer op een productpagina, in
   vier bewoordingen. Ze komen uit de mobiele mega-menu-trustline, de koopbox,
   de snelkaarten, de accordeon en de FAQ.

   Een eerdere versie herschreef alleen de eerste. Gevolg: een datum naast elf
   keer "3 werkdagen". Erger dan niets doen. Daarom twee passes:
     1. De hoofdregel in de koopbox krijgt de volledige belofte (datum + marge).
     2. Alle andere vindplaatsen krijgen alleen het JUISTE AANTAL DAGEN, met
        hun eigen zinsbouw intact.

   DERDE PASS: DE DUBBELE ONDERREGEL
   Onder de datum stond ook nog "Met zorg gemaakt en snel verzonden vanuit
   Nederland". Dat werd op mobiel twee regels, waardoor het blok drie regels
   hoog werd voor een mededeling die bovenaan de pagina al als badge staat
   ("Gemaakt in Nederland"). Die zin gaat uit; onze eigen onderregel over de
   marge blijft, want die zegt iets nieuws.

   TERUGVALGEDRAG
   Wordt er niets gevonden, dan gebeurt er niets en blijft de originele tekst
   staan. Nooit een lege plek, nooit een halve belofte.
   ========================================================================= */

(function () {
  'use strict';

  var CFG = window.WWC_CRO_ETA;
  if (!CFG) return;

  /* --- Teksten -----------------------------------------------------------
     Hier en niet in de locale-bestanden: het thema heeft geen sleutels
     hiervoor, en een ontbrekende sleutel toont letterlijk
     "Translation missing: ..." op de pagina. Buiten NL/DE/FR valt alles terug
     op Engels. */
  /* subTerm stond op "Meestal binnen {n} werkdagen" (en Usually / Meist /
     Généralement). Bedoeld als eerlijke marge, maar het leest als een slag om
     de arm precies op het moment dat iemand op de koopknop wil drukken - en
     dat terwijl de hoofdregel er BOVEN al een harde datum belooft
     ("Uiterlijk 21 augustus in huis"). Twee regels die samen zeggen: het is
     zeker, maar eigenlijk ook weer niet.

     De marge zit al in de berekening (res.days telt werkdagen inclusief
     productietijd en de knip van vandaag), dus "Binnen {n} werkdagen" is niet
     stelliger dan we waar kunnen maken - het is dezelfde belofte, zonder de
     verontschuldiging. */
  var STRINGS = {
    nl: { term: 'Binnen {n} werkdagen in huis', date: 'Uiterlijk {d} in huis', subTerm: 'Binnen {n} werkdagen', rush: 'Spoed? App ons' },
    en: { term: 'Delivered within {n} working days', date: 'Delivered by {d} at the latest', subTerm: 'Within {n} working days', rush: 'In a hurry? Message us' },
    de: { term: 'Lieferung innerhalb von {n} Werktagen', date: 'Spätestens am {d} geliefert', subTerm: 'Innerhalb von {n} Werktagen', rush: 'Eilig? Schreib uns' },
    fr: { term: 'Livré sous {n} jours ouvrés', date: 'Livré au plus tard le {d}', subTerm: 'Sous {n} jours ouvrés', rush: 'Urgent ? Écrivez-nous' }
  };

  var lang = (CFG.locale || 'nl').slice(0, 2).toLowerCase();
  var T = STRINGS[lang] || STRINGS.en;

  /* --- Werkdagen tellen -------------------------------------------------- */
  var weekend = (CFG.weekend || []).map(function (d) { return parseInt(d, 10); });
  var holidays = {};
  (CFG.holidays || []).forEach(function (h) { holidays[String(h).trim()] = true; });

  function iso(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function isWorkday(d) {
    if (weekend.indexOf(d.getDay()) !== -1) return false;
    if (holidays[iso(d)]) return false;
    return true;
  }

  function addWorkdays(start, n) {
    var d = new Date(start.getTime()), left = n, guard = 0;
    while (left > 0 && guard < 400) {
      d.setDate(d.getDate() + 1);
      if (isWorkday(d)) left--;
      guard++;
    }
    return d;
  }

  function compute() {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (typeof CFG.cutoffHour === 'number' && now.getHours() >= CFG.cutoffHour) {
      start.setDate(start.getDate() + 1);
    }
    var total = (CFG.pickupDays || 0) + (CFG.productionDays || 0) + (CFG.transitDays || 0);
    return { date: addWorkdays(start, total), days: total };
  }

  function formatDate(d) {
    try {
      return new Intl.DateTimeFormat(CFG.locale || lang, { weekday: 'long', day: 'numeric', month: 'long' }).format(d);
    } catch (e) { return iso(d); }
  }

  /* --- Vindplaatsen ------------------------------------------------------ */
  var ANY = /(binnen|within|innerhalb von|innerhalb|sous)(\s+)(\d+)(\s*)(werkdagen|working days|business days|werktagen|jours ouvrés|jours)/ig;
  /* MAIN mag NIET verankerd zijn op woordvolgorde. Dit stond er:

       /^\s*(binnen|within|innerhalb|sous)[^.]{0,30}(in huis|geleverd|...)/i

     Dat eist dat de zin BEGINT met "binnen/within" en pas daarna het werkwoord
     krijgt. Zo praat alleen het Nederlands: "Binnen 3 werkdagen in huis". Het
     Engels zet het werkwoord voorop ("Delivered within 3 working days"), het
     Duits ook ("Lieferung innerhalb von 3 Werktagen") en het Frans ("Livré
     sous 3 jours ouvrés"). Gevolg: op en/de/fr vond pass 1 geen hoofdregel, en
     dan valt ALLES stil - geen datum, geen subregel met de spoedlink, en pass 3
     verbergt de dubbele "vanuit Nederland"-regel niet, want die hangt aan
     `host` die hier gezet wordt. Drie van de vier talen zagen dus de kale
     terugvaltekst van het thema.

     Nu alleen nog: staat er een leverwerkwoord in? De rest van de zeef doet het
     werk (de node moet al ANY matchen, zichtbaar zijn en buiten de footer). */
  var MAIN = /(in huis|geleverd|delivered|geliefert|lieferung|livr)/i;

  // De zin die dubbelt met de badge bovenaan de pagina.
  var DUPE = /(vanuit nederland|made in the netherlands|from the netherlands|aus den niederlanden|depuis les pays-bas)/i;

  function collect() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node, out = [];
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      ANY.lastIndex = 0;
      if (!ANY.test(node.nodeValue)) continue;
      var el = node.parentElement;
      if (!el || el.closest('script, style, .wwc-lb')) continue;
      out.push(node);
    }
    return out;
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function run() {
    var nodes = collect();
    if (!nodes.length) return;

    var res = compute();
    var dateStr = formatDate(res.date);
    var mode = CFG.mode || 'both';

    /* Pass 1: de hoofdregel.

       EERST op PLEK zoeken en pas daarna op tekst. Het leverblok in de koopbox
       is de plek waar de datum hoort, en dat is in elke taal hetzelfde element.
       Een tekstpatroon kan de verkeerde regel pakken: de mobiele mega-menu-
       trustline zegt ook "Delivered within 3 business days", en die zou de
       datum dan wegkapen uit de koopbox.

       Blijft de tekstzoektocht als terugval staan, voor markup zonder dat blok
       (bijvoorbeeld de quick view). */
    var mainNode = null;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i].parentElement;
      if (!el || !el.closest('.wwc-delivery-trust')) continue;
      if (!isVisible(el)) continue;
      mainNode = nodes[i];
      break;
    }

    if (!mainNode) {
      for (var j = 0; j < nodes.length; j++) {
        var v = nodes[j].nodeValue.trim();
        if (v.length > 40) continue;
        if (!MAIN.test(v)) continue;
        if (!isVisible(nodes[j].parentElement)) continue;
        if (nodes[j].parentElement.closest('footer')) continue;
        mainNode = nodes[j];
        break;
      }
    }

    var host = null;

    if (mainNode && mode !== 'term') {
      mainNode.nodeValue = T.date.replace('{d}', dateStr);
      host = mainNode.parentElement;
      if (mode === 'both' && host && !host.querySelector('.wwc-cro-eta__sub')) {
        var span = document.createElement('span');
        span.className = 'wwc-cro-eta__sub';
        span.textContent = T.subTerm.replace('{n}', res.days);

        /* Spoedvraag in HETZELFDE vak als de levertijd. Stond als eigen
           ⚡-regel drie items lager in de vertrouwenslijst, terwijl het
           dezelfde vraag op hetzelfde moment is: wanneer heb ik hem, en als
           het sneller moet?

           createElement en geen innerHTML: het nummer komt uit de config en
           daar hoort geen markup-samenstelling bij. */
        if (CFG.wa && T.rush) {
          span.appendChild(document.createTextNode(' \u00b7 '));
          var wa = document.createElement('a');
          wa.className = 'wwc-wa wwc-cro-eta__spoed';
          wa.href = 'https://wa.me/' + String(CFG.wa).replace(/[^0-9]/g, '');
          wa.target = '_blank';
          wa.rel = 'noopener noreferrer';
          wa.textContent = T.rush;
          span.appendChild(wa);
        }

        host.appendChild(span);
      }
      if (host) host.setAttribute('data-wwc-eta', iso(res.date));
    }

    // Pass 2: overal elders alleen het aantal dagen kloppend maken.
    nodes.forEach(function (n) {
      if (n === mainNode && mode !== 'term') return;
      n.nodeValue = n.nodeValue.replace(ANY, function (m, p1, s1, num, s2, unit) {
        return p1 + s1 + res.days + s2 + unit;
      });
    });

    // Pass 3: de dubbele onderregel in hetzelfde blok verbergen.
    if (CFG.hideDupeLine !== false && host && host.parentElement) {
      Array.prototype.slice.call(host.parentElement.children).forEach(function (el) {
        if (el === host || el.contains(host)) return;
        var t = (el.textContent || '').trim();
        if (!t || t.length > 90) return;
        if (DUPE.test(t)) el.setAttribute('hidden', '');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* De quick view injecteert productmarkup NA het laden van de pagina. Zonder
     deze regel draait de herschrijving daar nooit en blijft de statische
     terugval "Binnen 3 werkdagen in huis" staan in plaats van de berekende
     datum. Het thema stuurt dit event zelf uit (assets/theme.js). */
  document.addEventListener('quickview:loaded', function () { run(); });
})();
